// theme.ts
import {
    createTheme,
    colorsTuple,
    DEFAULT_THEME,
    mergeMantineTheme,
    virtualColor
} from '@mantine/core';

const themeOverride = createTheme({
    fontFamily: 'Montserrat, Inter, system-ui, Avenir, Helvetica, Arial, sans-serif',
    colors: {
        'yenta-blue': [
            '#84b0c8', '#6ba0bd', '#5290b2', '#3980a7', '#21709c', // lighter
            '#086091', '#075683', '#064d74', '#064366', '#053a57', // darker
        ],
        'yenta': [
            '#84b0c8', '#6ba0bd', '#5290b2', '#3980a7', '#21709c', // lighter
            '#086091', '#075683', '#064d74', '#064366', '#053a57', // darker
        ],
        'yenta-light-blue': colorsTuple('#B9DCF4'),
        // 'active-dark': colorsTuple('#021127'),
        'active-dark': colorsTuple('var(--mantine-primary-color-9)'),
        'active-light': colorsTuple('var(--mantine-primary-color-0)'),
        'active-background': virtualColor({
            name: 'active-background',
            dark: 'active-dark',
            light: 'active-light'
        }),
    },
    primaryColor: 'yenta-blue',
    defaultRadius: '6px',
    autoContrast: true
});

// export const theme = mergeMantineTheme(DEFAULT_THEME, themeOverride);
export const theme = themeOverride;
export function buildTenantTheme(branding: { colorCode: string, logoUrl?: string | null } | null) {
    if (!branding) return theme;
  
    const tenantOverride = createTheme({
      primaryColor: 'tenantColor',
    //   fontFamily: branding.fontFamily,
      // Example: map their colors into your palette slots
      colors: {
        tenantColor: generateColorShades(branding.colorCode),
      },
      autoContrast: true,
      defaultRadius: '1px',
      other: {
        logoUrl: branding.logoUrl,
      },
    });
  
    // @ts-ignore
    return mergeMantineTheme(themeOverride, tenantOverride);
}

function generateColorShades(baseColor: string): readonly [string, string, string, string, string, string, string, string, string, string, ...string[]] {
    // Generate 10 shades from lighter to darker
    const shades: string[] = [];
    
    // Parse hex color
    const hex = baseColor.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Generate shades (0 = lightest, 9 = darkest)
    // Mantine expects shades from lightest to darkest
    for (let i = 0; i < 10; i++) {
        // Create a gradient: lighter shades (0-4) and darker shades (5-9)
        let newR, newG, newB;
        
        if (i <= 4) {
            // Lighter shades: blend with white
            const factor = 1 - (i * 0.15);
            newR = Math.round(r + (255 - r) * (1 - factor));
            newG = Math.round(g + (255 - g) * (1 - factor));
            newB = Math.round(b + (255 - b) * (1 - factor));
        } else {
            // Darker shades: darken the base color
            const factor = (i - 4) * 0.15;
            newR = Math.round(r * (1 - factor));
            newG = Math.round(g * (1 - factor));
            newB = Math.round(b * (1 - factor));
        }
        
        // Convert to hex
        const toHex = (n: number) => {
            const hex = Math.max(0, Math.min(255, n)).toString(16);
            return hex.length === 1 ? '0' + hex : hex;
        };
        shades.push(`#${toHex(newR)}${toHex(newG)}${toHex(newB)}`);
    }
    // @ts-ignore
    return shades.sort().reverse() as readonly [string, string, string, string, string, string, string, string, string, string, ...string[]];
}